import { render, staticRenderFns } from "./SubscriberOrders.vue?vue&type=template&id=4888d2b9&scoped=true"
import script from "./SubscriberOrders.vue?vue&type=script&lang=ts"
export * from "./SubscriberOrders.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4888d2b9",
  null
  
)

export default component.exports